<div
  class="messages-top-bar"
  [ngClass]="{ 'sidebar__messages-top-bar': (useSidebarStyles$ | async) }"
  *ngIf="conversationDetail$ | async"
>
  <div
    class="icon-back"
    [ngClass]="{ 'sidebar__icon-back': (useSidebarStyles$ | async) && (showInboxViews$ | async) }"
    (click)="back()"
  >
    <span class="material-icons">arrow_back</span>
  </div>

  <div class="messages-recipient">
    <div class="recipient-info">
      <div class="conversation-title" [ngClass]="{ 'clickable-title': !isBusinessApp }">
        <inbox-conversation-title
          [conversationDetail]="conversationDetail$ | async"
          [conversationClosed]="!isOpen"
          [displayOnTopBar]="true"
          (click)="toggleDetailsDrawer()"
        ></inbox-conversation-title>
      </div>
      <div class="recipient-details">
        <ng-container *ngIf="isInternalInfoDeleted">
          <glxy-badge [color]="'red'">{{ 'INBOX.INFO.DELETED' | translate }}</glxy-badge>
        </ng-container>
        <button mat-icon-button (click)="toggleDetailsDrawer()" *ngIf="!isBusinessApp">
          <mat-icon class="info-pane-button">info_outlined</mat-icon>
        </button>
      </div>
    </div>
    <inbox-conversation-account
      *ngIf="isBusinessApp"
      [conversationDetail]="conversationDetail$ | async"
    ></inbox-conversation-account>
    <inbox-conversation-assignee
      *ngIf="displayAssignee"
      [conversationDetail]="conversationDetail$ | async"
    ></inbox-conversation-assignee>
  </div>

  <div class="messages-actions">
    <ng-container *ngIf="showInboxViews$ | async">
      <!-- Small Button -->
      <button
        attr.data-action="clicked-conversation-follow-{{ (useSidebarStyles$ | async) ? 'sidebar' : 'fullview' }}"
        class="follow-button icon-button"
        mat-icon-button
        (click)="updateFollowStatus()"
        [matTooltip]="(isFollowing ? 'INBOX.VIEWS.FOLLOWING' : 'INBOX.VIEWS.FOLLOW') | translate"
        [ngClass]="{ 'follow-button-mobile': (useSidebarStyles$ | async) === false }"
      >
        <mat-icon>{{ isFollowing ? 'star' : 'star_border' }}</mat-icon>
      </button>

      <!-- Large Button -->
      <button
        attr.data-action="clicked-conversation-follow-{{ (useSidebarStyles$ | async) ? 'sidebar' : 'fullview' }}"
        class="follow-button follow-button-large"
        mat-stroked-button
        (click)="updateFollowStatus()"
        *ngIf="(useSidebarStyles$ | async) === false"
      >
        <mat-icon>{{ isFollowing ? 'star' : 'star_border' }}</mat-icon>
        {{ (isFollowing ? 'INBOX.VIEWS.FOLLOWING' : 'INBOX.VIEWS.FOLLOW') | translate }}
      </button>
    </ng-container>

    <button
      mat-icon-button
      class="icon-button"
      [matMenuTriggerFor]="menu"
      aria-label="More"
      data-action="clicked-menu-conversation-top-bar"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button
        *ngIf="showConversationSummary$ | async"
        mat-menu-item
        class="icon-button"
        aria-label="Summary"
        data-action="clicked-conversation-summary"
        (click)="openConversationSummaryModal()"
      >
        <div class="button-content">
          {{ 'INBOX.SENDER.SUMMARIZE_CONVERSATION' | translate }}
          <mat-icon svgIcon="galaxy-ai-icon" />
        </div>
      </button>
      <button
        mat-menu-item
        *ngIf="!(unseen$ | async)?.read; else markUnreadButton"
        (click)="markRead()"
        data-action="clicked-conversation-read"
      >
        <span>{{ 'INBOX.SENDER.MARK_READ' | translate }}</span>
      </button>
      <button mat-menu-item (click)="toggleDetailsDrawer()" *ngIf="!isBusinessApp">
        {{ 'INBOX.INFO.CONVERSATION_DETAILS' | translate }}
      </button>
      <ng-container *ngIf="showInboxViews$ | async">
        <button mat-menu-item (click)="updateFollowStatus()" class="icon-button">
          <div class="button-content">
            {{ (isFollowing ? 'INBOX.VIEWS.FOLLOWING' : 'INBOX.VIEWS.FOLLOW') | translate }}
            <mat-icon>{{ isFollowing ? 'star' : 'star_border' }}</mat-icon>
          </div>
        </button>
      </ng-container>
      <button mat-menu-item (click)="toggleConversationOpen()">
        {{ (isOpen ? 'INBOX.SENDER.CLOSE_CONVERSATION' : 'INBOX.SENDER.OPEN_CONVERSATION') | translate }}
      </button>

      <!-- Kabob Dynamic Available Actions -->
      <ng-container *ngFor="let action of kabobAvailableActions$ | async">
        <button mat-menu-item (click)="action.action()" [attr.data-action]="action.posthogLabel">
          <span>{{ action.title | translate }}</span>
        </button>
      </ng-container>
    </mat-menu>
  </div>
</div>

<ng-template #markUnreadButton>
  <button mat-menu-item (click)="markUnread()" data-action="clicked-conversation-unread">
    <span>{{ 'INBOX.SENDER.MARK_UNREAD' | translate }}</span>
  </button>
</ng-template>
